import React, { useState } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';

export function NumberPicker(props) {
  const [value, setNumber] = useState(props?.value ?? 0);

  const handleIncrement = () => {
    props?.onUpdate (Math.min(value+1), 99)
    setNumber(prevValue => Math.min(prevValue + 1, 99));
  };

  const handleDecrement = () => {
    props?.onUpdate (Math.max(value-1), 0)
    setNumber(prevValue => Math.max(0, prevValue - 1)); // Prevent going below 0
  };

  const handleChange = (e) => {
    const num = parseInt(e.target.value, 10);
    if (!isNaN(num) && num >=0 && num < 100) {
      setNumber(num);
      props?.onUpdate(num)
    }
  };

  return (
    <InputGroup  style={{ width: '8.2em' }}>
      <Button variant="outline-secondary" onClick={handleDecrement}>-</Button>
      <Form.Control
        type="number"
        value={value}
        onChange={handleChange}
        min={0} max={99}
      />
      <Button variant="outline-secondary" onClick={handleIncrement}>+</Button>
    </InputGroup>
  );
}